import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import Header from '../shared/components/Header'
import Menu from '../shared/components/Menu'
import Footor from '../shared/components/Footer'
import { ResetPasswordType } from './model'
import ResetPassword from 'src/shared/components/ResetPassword'
// import Loading from 'src/shared/components/Loading'
import useStyles from './useStyles'
import useGetAccountPermission from 'src/shared/services/getAccountPermission/hooks'

const ErrorPage = lazy(() => import('./ErrorPage'))
const SearchResultPage = lazy(() => import('./Product/SearchResult'))

const ProductDetail = lazy(() => import('./Product/ProductDetail'))
const ProcessingOrders = lazy(() => import('./Orders/ProcessingOrders'))
const FinishedOrders = lazy(() => import('./Orders/FinishedOrders'))
const pagesItem = [
  {
    path: 'home',
    lazy: lazy(() => import('./Home')),
  },
  {
    path: 'custom/mirror-modification',
    lazy: lazy(() => import('./MirrorModification')),
  },
  {
    path: 'about/about-btox-ec',
    lazy: lazy(() => import('./AboutBtoxEc')),
  },
  {
    path: 'about/contact',
    lazy: lazy(() => import('./Contact')),
  },
  {
    path: 'custom/about-order',
    lazy: lazy(() => import('./AboutOrders')),
  },
  {
    path: 'custom/about-payment',
    lazy: lazy(() => import('./AboutPayment')),
  },
  {
    path: 'custom/service-announcement',
    lazy: lazy(() => import('./ServiceAnnouncement')),
  },
  {
    path: 'custom/privacy-policy',
    lazy: lazy(() => import('./PrivacyPolicy')),
  },
  {
    path: 'custom/faq',
    lazy: lazy(() => import('./Faq')),
  },
  {
    path: 'udi/:id',
    lazy: lazy(() => import('./Udi')),
  },
  {
    path: 'news/:id',
    exact: true,
    lazy: lazy(() => import('./News/NewsDetail')),
  },
  {
    path: 'news',
    lazy: lazy(() => import('./News')),
  },
  {
    path: 'patients',
    lazy: lazy(() => import('./Patients')),
  },
  {
    path: 'presets',
    lazy: lazy(() => import('./Presets')),
  },
  {
    path: 'custom/about-downloading',
    lazy: lazy(() => import('./AboutDownLoad')),
  },
  {
    path: 'account-info',
    lazy: lazy(() => import('./AccountInfo')),
  },
  { path: 'orders/pending', lazy: lazy(() => import('./Orders/PendingOrders')) },
]

const Pages: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false)
  const [isResetPasswordOpen, setIsPasswordOpen] = React.useState(false)
  const { path } = useRouteMatch()
  const history = useHistory()
  const classes = useStyles()
  const [keyword, setKeyword] = React.useState('')

  const { data: permission } = useGetAccountPermission()
  const customer_id = permission?.data.result_data.customer_id
  const userId = permission?.data.result_data.user_id || NaN

  const doSubmitAutoComplete = (value: string) => {
    setKeyword(value)
    history.push(`/pages/products/search-results?key=${encodeURIComponent(value)}`, { isSearch: true })
  }

  // const productMenu = permission?.data.result_data.roles.filter((ro) => ro.menu_name_en === 'Product')[0]

  const menuData = permission?.data.result_data.roles
    .filter((ro) => ro.menu_name !== 'Header')
    .filter((ro) => {
      if (userId === 123) {
        return ro.menu_name_en !== 'Order Management' && ro.menu_name_en !== 'Product'
      }
      return true
    })
    .map((menu) => ({
      id: menu.id,
      parentId: menu.parent_id,
      icon: menu.menu_icon,
      path: menu.menu_path,
      menu_name_ch: menu.menu_name_ch,
      menu_name_en: menu.menu_name_en,
      key: menu.menu_name_en,
      arrow: !menu.sub_menu, // if submenu exists, close tab for default.
      ...(menu.sub_menu && {
        sub_menu: menu.sub_menu.map((sbMenu) => ({
          id: sbMenu.id,
          parentId: sbMenu.parent_id,
          icon: null,
          path: sbMenu.parent_path ? `${sbMenu.parent_path}/${sbMenu.menu_path}` : sbMenu.menu_path,
          menu_name_ch: sbMenu.menu_name_ch,
          menu_name_en: sbMenu.menu_name_en,
          key: sbMenu.menu_name_en,
        })),
      }),
    }))

  return (
    <>
      <div className={classes.root}>
        <ResetPasswordType.Provider value={{ setIsPasswordOpen }}>
          <Header doSubmitAutoComplete={doSubmitAutoComplete} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
          <Footor setPassOpen={setIsPasswordOpen} />
        </ResetPasswordType.Provider>
        <ResetPassword
          open={isResetPasswordOpen}
          onClose={() => setIsPasswordOpen(false)}
          onBackdropClick={() => setIsPasswordOpen(false)}
          isModifiedMode
        />
        <Menu menuData={menuData} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        <main className={classes.content}>
          <div className={`${classes.page} custom_scrollbar`}>
            <Suspense
              fallback={
                // <Loading />
                null
              }
            >
              <Switch>
                {pagesItem.map((i) => {
                  return <Route exact={i.exact} path={`${path}/${i.path}`} component={i.lazy} key={i.path} />
                })}
                <Route path={`${path}/products/search-results`} exact>
                  <SearchResultPage keyword={keyword} customer_id={permission?.data.result_data.customer_id} />
                </Route>
                <Route path={`${path}/products/search-results/:type_id`}>
                  <SearchResultPage keyword={keyword} customer_id={permission?.data.result_data.customer_id} />
                </Route>
                <Route path={`${path}/products/product-detail/:basic_id`}>
                  <ProductDetail customer_id={customer_id} />
                </Route>
                <Route path={`${path}/orders/processing`}>
                  <ProcessingOrders />
                </Route>
                <Route path={`${path}/orders/finished`}>
                  <FinishedOrders />
                </Route>
                <Redirect exact from={path} to={`${path}/home`} />

                <Route path='*'>
                  <ErrorPage />
                </Route>
              </Switch>
            </Suspense>
          </div>
        </main>
      </div>
      <Footor setPassOpen={setIsPasswordOpen} />
    </>
  )
}

export default Pages
